import { clampCount } from '../../lib/checklistGrouping';
import { Stamp } from '../Stamp';

interface TaskControlProps {
  count: number;
  maxCount: number;
  label: string;
  disabled?: boolean;
  onChange: (count: number) => void;
}

/** A stamp checkbox (see `components/Stamp`) for `maxCount === 1` tasks, an n/max +/- stepper otherwise. */
export function TaskControl({ count, maxCount, label, disabled = false, onChange }: TaskControlProps) {
  if (maxCount <= 1) {
    return (
      <Stamp
        checked={count >= maxCount}
        disabled={disabled}
        ariaLabel={label}
        onChange={(checked) => onChange(checked ? 1 : 0)}
      />
    );
  }

  const maxed = count >= maxCount;

  return (
    <div className="flex items-center justify-center gap-1">
      <button
        type="button"
        disabled={disabled || count <= 0}
        aria-label={`Decrease ${label}`}
        onClick={() => onChange(clampCount(count, -1, maxCount))}
        className="flex min-h-tap min-w-tap shrink-0 items-center justify-center rounded-md text-text-muted transition-colors hover:bg-bg-elevated-hover disabled:opacity-30"
      >
        −
      </button>
      <span
        className={[
          'w-11 rounded-full py-0.5 text-center text-xs font-semibold tabular-nums transition-colors',
          maxed ? 'bg-accent-dim text-accent' : 'text-text-muted',
        ].join(' ')}
      >
        {count}/{maxCount}
      </span>
      <button
        type="button"
        disabled={disabled || count >= maxCount}
        aria-label={`Increase ${label}`}
        onClick={() => onChange(clampCount(count, 1, maxCount))}
        className="flex min-h-tap min-w-tap shrink-0 items-center justify-center rounded-md text-text-muted transition-colors hover:bg-bg-elevated-hover disabled:opacity-30"
      >
        +
      </button>
    </div>
  );
}
